class AccountCtrl {

    constructor($scope, $routeParams,  $uibModal, ApiService, CONTENT_TYPE, EVENTS, $filter, $location, Notification, $rootScope) {

        $scope.pagination = {
            itemsPerPage: 25,
            page: 1
        };

        this.$scope = $scope;
        $scope.account = null;
        $scope.advertisers = [];
        $scope.numberSelected = 0;
        $scope.error = false;
        $scope.noResults = false;
        $scope.loading = true;
        this.$scope.isCopying = false;
        this.$scope.isDeleting = false;
        this.$scope.selectAll = false;
        this.$filter = $filter;
        this.accountId = $routeParams.accountId;
        $scope.accountId = $routeParams.accountId;
        $scope.itemsSelected = false;
        this.ApiService = ApiService;
        this.$uibModal = $uibModal;
        this.contentType = CONTENT_TYPE.ADVERTISER;
        this.$location = $location;
        this.Notification = Notification;
        this.EVENTS = EVENTS;
        $scope.itemsSelected = false;
        $scope.selectedItems = {};

        ApiService.get(CONTENT_TYPE.ACCOUNT, $routeParams.accountId)
        .then((response) => {
            $scope.account = response.data;
            $scope.$emit(EVENTS.SET_TITLE, $scope.account.name);
            if (response.data.length === 0) {
                $scope.noResults = true;
            }
            console.log($scope.account);
        }, (response) => {
            $scope.error = true;
            console.error(response);
        });

        $scope.$watch('selectedItems', (newVal) => {
            let selected = false;
            Object.keys(newVal).forEach(key => {
                if(newVal[key]) { selected = true; }
            });
            $scope.itemsSelected = selected;
        },  true);

        $scope.$watch('test.hi', (newVal, oldVal) => {
            console.log(newVal, oldVal);
        });


        $scope.$watch('tableFilter', this.advertiserFilter.bind(this));

        this.$scope.addAdvertiser = this.addAdvertiser.bind(this);
        this.$scope.updateAdvertiser = this.updateAdvertiser.bind(this);
        this.$scope.refreshAdvertisers = this.refreshAdvertisers.bind(this);
        this.$scope.deleteAdvertiser = this.deleteAdvertiser.bind(this);
        this.$scope.selectOrDeselectAll = this.selectOrDeselectAll.bind(this);
        this.$scope.deleteSelected = this.deleteSelected.bind(this);
        this.$scope.copySelected = this.copySelected.bind(this);
        this.$scope.sortTable = this.sortTable.bind(this);
        this.$scope.tableSort = "name";

        this.$scope.copy = this.copy.bind(this);

        $rootScope.$on(this.EVENTS.COPY_COMPLETE, (event, entity) => {
            if(entity.accountId == this.accountId) {
                this.refreshAdvertisers();
            }
            this.$scope.isCopying = false;
        });

        this.$scope.refreshAdvertisers();
    }

    copySelected() {
        let toCopy = [];

        $.each(this.$scope.selectedItems, (advertiserId, selected) => { 
            if(selected) {
                let advertiser = this.$scope.advertisers.filter(a => a.id == advertiserId)[0];
                toCopy.push(advertiser);
            }
        });

        let multiple = true;

        if(toCopy.length == 1) { 
            toCopy = toCopy[0]; 
            multiple = false;
        }

        this.copy(toCopy, multiple);

    }

    sortTable(key) {
        console.log(key);
        if (this.$scope.tableSort === '-' + key) {
            this.$scope.tableSort = key;
        } else {
            this.$scope.tableSort = '-' + key;
        }
    }

    addAdvertiser() {
        var modalInstance = this.$uibModal.open({
            animation: this.$scope.animationsEnabled,
            templateUrl: 'account/add-account.html',
            controller: 'AddItemCtrl',
            resolve: {
            },
            scope :this.$scope
        });

        modalInstance.result.then((newItem) => {
            this.createAdvertiser(newItem);
        }, () => {
            
        });

    }

    createAdvertiser(newItem) {
        let advertiser = {
            accountId: this.accountId,
            name: newItem.name
        };

        this.ApiService.create(this.contentType, advertiser)
            .then((response) => {
                this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Advertiser "' + response.data.name + '" created.'});

                //Create folder in account's folder here

                this.$location.path('/account/' + this.$scope.account.id + '/' + response.data.id);
                
            }, (response) => {

                if (response.status === 404) {
                    this.$scope.noResults = true;
                }
                console.error(response);
                this.$scope.error = true;
            });
    }

    updateAdvertiser(updatedItem) {

        let advertiser = {
            advertiserId: updatedItem.id,
            accountId: parseFloat(this.accountId),
            name: updatedItem.name
        };

        this.ApiService.update(this.contentType, advertiser)
            .then((response) => {
                this.refreshAdvertisers();
            }, (response) => {
                console.error(response);
                this.$scope.error = true;
        });
    }

    deleteAdvertiser(advertiser) {
        var modalInstance = this.$uibModal.open({
            animation: this.$scope.animationsEnabled,
            templateUrl: 'delete-confirm.html',
            controller: 'DeleteConfirmationCtrl'
        });

        modalInstance.result.then(() => {

            this.$scope.isDeleting = true;
            this.ApiService.delete(this.contentType, advertiser.id)
                .then((response) => {
                    this.refreshAdvertisers();
                    this.$scope.isDeleting = false;
                }, (response) => {
                    console.error(response);
                    this.$scope.error = true;
                    this.$scope.isDeleting = false;
                });
        }, () => this.$scope.isDeleting = false);
    }

    refreshAdvertisers() {
        this.$scope.noResults = false;
        this.$scope.loading = true;
        this.ApiService.list(this.contentType, "account=" + this.accountId)
            .then((response) => {
                this.$scope.advertisers = response.data;
                this.advertiserFilter();
                this.$scope.loading = false;
                if (response.data.length === 0) {
                    this.$scope.noResults = true;
                }
            }, (response) => {
                if (response.status === 404) {
                    this.$scope.noResults = true;
                } else {
                    console.error(response);
                    this.$scope.error = true;
                }
                this.$scope.loading = false;
            });
        }

    advertiserFilter() {
        let filtered = this.$filter('filter')(this.$scope.advertisers, this.$scope.tableFilter);
        this.$scope.availableItems = filtered.length;
    }

    selectOrDeselectAll() {
        this.$scope.selectAll = ! this.$scope.selectAll;

        this.$scope.selectedItems = {};
        if(this.$scope.selectAll) {
            this.$scope.advertisers.forEach(advertiser => { 
                this.$scope.selectedItems[advertiser.id] = true;
            });
        }
    }

    deleteSelected() {
        let toDelete = [];
        
        $.each(this.$scope.selectedItems, (advertiserId, selected) => { 
            if(selected) {
                let advertiser = this.$scope.advertisers.filter(a => a.id == advertiserId)[0];
                toDelete.push(advertiser);
            }
        });

        var modalInstance = this.$uibModal.open({
            animation: this.$scope.animationsEnabled,
            templateUrl: 'delete-confirm.html',
            controller: 'DeleteConfirmationCtrl'
        });

        modalInstance.result.then(() => {

            this.$scope.isDeleting = true;
            toDelete.forEach((advertiser, i) => {
                this.ApiService.delete(this.contentType, advertiser.id)
                    .then((response) => {
                        if(i == toDelete.length - 1) {
                            this.$scope.isDeleting = false;
                            this.refreshAdvertisers();
                        }
                    }, (response) => {
                        console.error(response);
                        this.$scope.isDeleting = false;
                        this.$scope.error = true;
                    });
            });
        },() => this.$scope.isDeleting = false);
    }

    copy(advertiser, multiple) {

        this.$scope.isCopying = true;

        let titleName = "";

        if(!!!multiple) { 
            multiple = false; 
        }
        else if(!multiple) {
            titleName = advertiser.name;
        }

        var modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'components/copy-entity-modal.html',
            controller: 'CopyEntityCtrl',
            resolve: {
                entity: () => advertiser,
                multiple: () => multiple,
                title: () => "Choose an advertiser to copy " + titleName + " to..."
            }
        });

        modalInstance.result.then(item => this.$scope.isCopying = false, () => this.$scope.isCopying = false);
    }

}


angular.module("cpm").controller("AccountCtrl", ['$scope', '$routeParams', '$uibModal', 'ApiService', 'CONTENT_TYPE', 'EVENTS', '$filter', '$location', 'Notification', '$rootScope', AccountCtrl]);
